module.exports = __webpack_public_path__ + "img/hr-branch-particle-04.c1760724.png";